import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomerPageAction: (state, action) => {
            state.page = action.payload
        },
        getCustomerPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addCustomerAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateCustomerAction: (state, action) => {
            const content = state.page.content.map((x) => {
                if (x.id === action.payload.id) return action.payload
                else return x
            })
            state.page.content = content
        },
        deleteCustomerAction: (state, action) => {
            const content = state.page.content.filter(x => x.id !== action.payload)
            state.page.content = content
        },
        uploadCustomerExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        }
    },
});

export const { setCustomerPageAction, getCustomerPageAction, addCustomerAction, updateCustomerAction, deleteCustomerAction, uploadCustomerExcelFileAction } = customerSlice.actions;
export default customerSlice;